import {useTranslation} from 'react-i18next'

import {WalletIcon} from '~/react/icons'
import {useProductEnabled} from './useProductEnabled'
import {usePermissions} from './usePermissions'

export const useSideNavLinks = () => {
  const {t} = useTranslation('pointsOnPayments')
  const {data, isLoading} = usePermissions()
  const {enabled} = useProductEnabled()

  const generalLinks = enabled
    ? [
        {
          disabled: false,
          visible: true,
          label: t('pointsOnPayments:sideNav.generalLinks.billsIndexLabel'),
          icon: <WalletIcon />,
          href: '/points_on_payments/bills',
        },
      ]
    : []

  const settingsUnlocked = data?.screenAccess?.settingsScreen

  return {
    isLoading,
    generalLinks,
    settingsUnlocked,
  }
}
